export default __webpack_public_path__ + "static/Kalam-Light-744d09ac939b6bb8a4a6dd8670962c46.woff2";